// GET /categories lists every admin category. One the serving outlet has
// switched off comes back with `isActive: false` (and `hiddenAtOutlet`); the
// backend expects clients to hide it. This honours that flag — it is not a
// client-side outlet decision.
export const visibleCategories = (list) =>
  (Array.isArray(list) ? list : []).filter((category) => category && category.isActive !== false);
